module.exports = __webpack_public_path__ + "img/NHWB1.6e4f5839.webp";